module.exports = __webpack_public_path__ + "fonts/Calibre-RegularItalic.3a445970.woff";